import React from "react";
import { Grid, InputLabel, TextField } from "@mui/material";
import FormControl from '@mui/material/FormControl';

const cl = "app-component-addticket";
function AddAgent() {
   
    return (
        <>
            <div className={`${cl}`}>
                <div className={`${cl}__card`}>
                    <Grid container spacing={3}>
                        <Grid item md={6}>
                            <div className="app-form-fields">
                                <FormControl fullWidth>
                                    <TextField size="medium" required id="outlined-basic" label="Name" placeholder="Enter name" type="primary" variant="outlined" />
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item md={6}>
                            <div className="app-form-fields">
                                <FormControl fullWidth>
                                    <TextField size="medium" required id="outlined-basic" label="Email" placeholder="Enter email" type="primary" variant="outlined" />
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item md={6}>
                            <div className="app-form-fields">
                                <FormControl fullWidth>
                                    <TextField size="medium" required id="outlined-basic" label="Phone" placeholder="Enter phone" type="primary" variant="outlined" />
                                </FormControl>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </>
    )
}
export default AddAgent;
